<template>
    <div
        class="modal fixed"
        aria-labelledby="add-card-modal-title"
        role="dialog"
        aria-modal="true"
        v-show="show"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div class="inner" style="-webkit-transform:translate3d(0,0,0);">
            <a href="#" class="modal-close-btn text-orange" role="button" @click.prevent="close"
                ><i class="fal fa-times"></i
            ></a>
            <div class="modal-body items-start p-8 border-t-4 border-solid border-t-orange">
                <p class="text-xl mb-2">
                    We need to resolve the challenge questions for your {{ member.name }} account.
                    Please answer the below challenge question in order to connect your institution.
                </p>
                <div class="relative">
                    <Loading :show="showLoading" />
                    <form id="challenge-form">
                        <div
                            v-for="challenge in challenges"
                            class="mb-2 pt-3 pb-3"
                            :key="challenge.guid"
                        >
                            <label>
                                <span class="block w-full mb-2 text-lg">{{ challenge.label }}</span>
                                <input
                                    v-if="challenge.type === 'TEXT'"
                                    type="text"
                                    class="form-input w-full"
                                    :name="challenge.guid"
                                    v-model="challenge.answer"
                                    required
                                />
                                <select
                                    v-if="challenge.type === 'OPTIONS'"
                                    :name="challenge.guid"
                                    class="form-select w-full"
                                    v-model="challenge.answer"
                                    required
                                >
                                    <option value=""></option>
                                    <option
                                        v-for="option in challenge.options"
                                        :value="option.value"
                                        :key="option.value"
                                    >
                                        {{ option.label }}
                                    </option>
                                </select>

                                <img
                                    v-if="challenge.type === 'IMAGE_DATA'"
                                    class="image-option mb-4"
                                    :src="challenge.image_data"
                                    :alt="challenge.label"
                                />
                                <input
                                    v-if="challenge.type === 'IMAGE_DATA'"
                                    type="text"
                                    class="form-input w-full"
                                    :name="challenge.guid"
                                    placeholder="Answer here ..."
                                    v-model="challenge.answer"
                                    required
                                />
                            </label>
                            <div v-if="challenge.type === 'IMAGE_OPTIONS'">
                                <label
                                    class="
                                        relative
                                        inline-block
                                        m-3
                                        cursor-pointer
                                        hover:opacity-60
                                    "
                                    v-for="(option, i) in challenge.image_options"
                                    :key="'image-option-' + i"
                                >
                                    <input
                                        type="radio"
                                        :name="challenge.guid"
                                        :value="option.value"
                                        class="image-option-value hidden"
                                        v-model="challenge.answer"
                                    />
                                    <span><i class="fal fa-check-circle"></i></span>
                                    <img
                                        :src="option.data_uri"
                                        class="image-option"
                                        :alt="challenge.label"
                                    />
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer bg-gray-100">
                <button
                    type="button"
                    @click="submitAnswer"
                    class="btn-base btn-dark"
                    :disabled="submittingAnswer"
                    id="hs-wallet-challenges-submit"
                >
                    Submit Answer
                    <span class="inline ml-2" v-if="submittingAnswer"
                        ><i class="fas fa-spinner-third fa-spin"></i
                    ></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@/components/loading.vue';

export default {
    name: 'ChallengesModal',
    props: {
        member: {
            type: Object,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Loading,
    },
    watch: {
        show(newVal, oldVal) {
            if (newVal) {
                this.getChallenges();
            }
        },
    },
    data: () => ({
        showLoading: false,
        submittingAnswer: false,
        challenges: [],
    }),
    methods: {
        getChallenges() {
            this.showLoading = true;
            ApiService.apiCall('/members/' + this.member.guid + '/challenges', 'get')
                .then((response) => {
                    this.challenges = response.data.challenges;
                    this.showLoading = false;
                })
                .catch((response) => {
                    this.showLoading = false;
                    this.$root.handleHttpStatus(response);
                });
        },
        submitAnswer() {
            this.submittingAnswer = true;
            let answered = false;
            let answers = [];

            this.challenges.forEach((el) => {
                answers.push({ guid: el.guid, answer: el.answer });
                if (el.answer && el.answer.length > 0) {
                    answered = true;
                }
            });

            if (answered) {
                let data = {
                    challenge_answers: answers,
                };

                ApiService.apiCall('/members/' + this.member.guid + '/resume', 'put', data)
                    .then((response) => {
                        if (response.data.success) {
                            this.$notify(
                                {
                                    group: 'success',
                                    title: 'Success',
                                    text: 'The challenge request was successful.',
                                },
                                4000
                            );
                            this.$emit('success');
                            this.$emit('close');
                        } else {
                            this.$notify(
                                {
                                    group: 'error',
                                    title: 'Error',
                                    text:
                                        'The request was ' +
                                        response.data.status +
                                        '. Please try again or contact support.',
                                },
                                4000
                            );
                        }
                        this.submittingAnswer = false;
                    })
                    .catch((response) => {
                        this.$root.handleHttpStatus(response);
                        this.submittingAnswer = false;
                    });
            } else {
                this.$notify(
                    {
                        group: 'error',
                        title: 'Error',
                        text: 'Please enter your challenge request.',
                    },
                    4000
                );
                this.submittingAnswer = false;
            }
        },
        close() {
            this.$emit('close');
        },
    },
    mounted() {},
};
</script>
<style lang="scss" scoped>
.image-option {
    max-width: 140px;
    height: auto;
}
.image-option-value + span {
    display: none;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    font-size: 42px;
    border-radius: 50%;
    background-color: #fff;
    line-height: 1;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}
.image-option-value:checked + span {
    display: flex;
}
</style>
